import { useFilters } from '~/core/shared/api/middle-office/filters';
import { useTenantedApplicationConfig } from '~/core/shared/contexts';
import { buildDefinitionParams } from '../logic/buildDefinitionParams';

export const useFiltersQuery = (definition?: string) => {
  const config = useTenantedApplicationConfig();
  return useFilters(buildDefinitionParams(definition, config));
};
